export default "__VITE_ASSET__5How_f$k__"